import { type Dispatch, type SetStateAction, useState } from 'react'

import { IconButton, MenuItem } from '@mui/material'
import { Icon } from 'components'
import { type CustomBoolean, TypesValidations } from 'constants/enums'
import type { DraftProps } from 'container/Home/components/Banners/interface'
import type { FormatBodyType } from 'container/ManageOrders/utils'
import ModalVerOvs from 'container/SalesOrder/components/ModalVerOvs'
import { asyncGetCorpoRascunho, setDuplicateOrder } from 'store/SalesOrderContext/salesOrderSlice'
import { useDispatch, useSelector } from 'store/store'
import { theme } from 'styles/theme/hav-theme'

import * as S from './styles'

type SalesOrderMenuProps = {
  draft: DraftProps
  getOrdersData: (body?: FormatBodyType) => Promise<void>
  draftsPage: number
  setSelectedDraft: Dispatch<SetStateAction<string>>
  selectedDraft: string
  setModalDuplicate: Dispatch<SetStateAction<boolean>>
  setModalPostOn: Dispatch<SetStateAction<boolean>>
  modalDuplicate: boolean
}

const SalesOrderMenu = ({
  draft,
  setSelectedDraft,
  selectedDraft,
  setModalDuplicate,
  setModalPostOn,
  modalDuplicate,
}: SalesOrderMenuProps) => {
  const dispatch = useDispatch()
  const { duplicateOrder } = useSelector(({ salesOrder }) => salesOrder)
  const [modalVerOvs, setModalVerOvs] = useState(false)

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClickDuplicate = () => {
    setModalDuplicate(!modalDuplicate)
  }

  const openPostOn = () => {
    setModalPostOn(true)
  }

  const handleClick = (
    event: React.MouseEvent<HTMLElement>,
    nrDraft: string,
    fl_mto_prep: CustomBoolean,
    cd_clie: string,
  ) => {
    event.preventDefault()
    setSelectedDraft(nrDraft)
    setAnchorEl(event.currentTarget)
    dispatch(asyncGetCorpoRascunho(nrDraft))
    dispatch(
      setDuplicateOrder({
        ...duplicateOrder,
        Clientes: [
          {
            cd_clie: cd_clie,
            fl_dupl_matr: TypesValidations.YES,
            fl_dupl_text: TypesValidations.YES,
            fl_mto_prep: fl_mto_prep,
            nr_pedi_clie: '',
          },
        ],
        nr_pedi_rasc_orig: nrDraft,
      }),
    )
  }

  return (
    <>
      <IconButton
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        id="long-button"
        onClick={(e) => {
          handleClick(e, draft.NumeroPedidoRascunho, draft.TipoMaterial, draft.CodigoCliente)
        }}
        style={{
          background: '#fff',
          borderRadius: 5,
          height: 30,
          padding: 0,
          width: 30,
        }}
        type="button"
      >
        <Icon color={theme.colors.primary.main} icon="ellipsis" size="15" />
      </IconButton>
      <S.MenuStyled
        anchorEl={anchorEl}
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        onClose={handleClose}
        open={open && draft.NumeroPedidoRascunho === selectedDraft}
      >
        <MenuItem
          onClick={() => {
            handleClickDuplicate()
            handleClose()
          }}
        >
          Duplicar
        </MenuItem>

        <MenuItem
          onClick={() => {
            openPostOn()
            handleClose()
          }}
        >
          Listar
        </MenuItem>
        {draft.OrdensVendas.length > 0 && (
          <MenuItem
            onClick={() => {
              setModalVerOvs(true)
              handleClose()
            }}
          >
            Ver OVs
          </MenuItem>
        )}
      </S.MenuStyled>
      <ModalVerOvs
        isOpen={modalVerOvs && selectedDraft === draft.NumeroPedidoRascunho}
        ordensVenda={draft.OrdensVendas}
        orderNumber={draft.NumeroPedidoRascunho}
        setIsOpen={setModalVerOvs}
      />
    </>
  )
}

export default SalesOrderMenu
